module.exports = __webpack_public_path__ + "static/media/logo-shopee.4125c721.jpg";